import styled, { css } from 'styled-components';

export const Container = styled.div<{ $z: number; $interactive: boolean }>`
  touch-action: ${({ $z, $interactive }) => {
    if (!$interactive) return 'auto';

    return $z === 1 ? 'pan-y pinch-zoom' : 'none';
  }};
  height: 100%;
`;

export const Wrapper = styled.div<{ $z: number }>`
  transition: transform linear 100ms;
  will-change: transform;
  height: 100%;
  display: flex;
  align-items: center;

  ${({ $z }) =>
    $z !== 1
      ? css`
          cursor: grab;
        `
      : ''}
`;

export const Image = styled.img<{ translateX: number; translateY: number; scale: number }>`
  transform-origin: 0 0;
  transform: scale(${(props) => props.scale})
    translate(${(props) => props.translateX}px, ${(props) => props.translateY}px);
  transition: transform 0.2s ease-out;
  will-change: transform;
`;
